import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import * as FeatherIcons from 'react-feather';
import Button from '../Button/Button';
import { ButtonVariants } from '../Button/Button.types';
import Icon from '../Icons/Icon';
import styles from './DashboardCard.module.css';
import { useTranslation } from 'react-i18next';

interface DashboardCardProps {
  title: string;
  onViewClick: () => void;
  titleIcon?: keyof typeof FeatherIcons;
  children?: ReactNode;
  className?: string;
  buttonAriaLabel?: string;
}

const DashboardCard: FC<DashboardCardProps> = ({
  title,
  onViewClick,
  titleIcon,
  children,
  className,
  buttonAriaLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.card, { [className!]: className !== undefined })}>
      <div className={styles.header}>
        <div className={styles.title}>
          {titleIcon && <Icon iconName={titleIcon} />}
          {title}
        </div>
        <Button onClick={onViewClick} variant={ButtonVariants.Text} aria-label={buttonAriaLabel}>
          {t('common.viewButton')}
        </Button>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default DashboardCard;
